import { render } from "./AuthLayout.vue?vue&type=template&id=115ff64e&ts=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=115ff64e&lang=css"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__